module.exports = __webpack_public_path__ + "static/media/font_medium.08952b02.woff2";